export enum ExportId {
  ACTIVE_PRESCRIBERS = 'active_prescribers',
  ACTIVE_ADMINS = 'active_admins',
  PRESCRIPTIONS_BY_PRESCRIBER = 'prescriptions_by_prescriber',
  PRESCRIPTIONS = 'prescriptions',
  PRESCRIBED_ITEMS = 'prescribed_items',
  LITE_PRESCRIBED_ITEMS = 'lite_prescribed_items',
}

export type ExportIconVariant = 'blue' | 'green' | 'purple' | 'amber'

export type ReportsTab = 'analytics' | 'exports'

export interface ExportDefinition {
  id: ExportId
  name: string
  description: string
  iconVariant: ExportIconVariant
  requiresMonth?: boolean
}

export interface ExportSectionDefinition {
  title: string
  exports: ExportDefinition[]
}
